import { Button, ButtonLink } from '@/components/ui/button'
import { useLingui } from '@lingui/react/macro'
import { CheckIcon } from 'lucide-react'

export function Pricing(props: { setOpenContact: (open: boolean) => void; userType: 'applicant' | 'company' }) {
  const { t } = useLingui()

  return (
    <section className="relative overflow-hidden">
      <h2 className="mb-15 text-center text-3xl font-semibold">{t`Choose your plan and start now`}</h2>

      <div className="mx-auto mb-37.5 flex max-w-200 items-center justify-center font-medium max-md:flex-col">
        <div className="m-1.25 flex min-w-1/3 flex-col gap-3 rounded-lg border p-7.5">
          <h3 className="font-medium">{t`Free`}</h3>
          <p className="text-sm font-medium">{t`You can try all our products`}</p>

          <ul className="flex flex-col gap-1 text-sm font-medium">
            <li className="flex gap-2">
              <CheckIcon className="text-primary size-5 shrink-0" />
              {t`5 reports on positions, professionals, and teams`}
            </li>
            <li className="flex gap-2">
              <CheckIcon className="text-primary size-5 shrink-0" />
              {t`5 comparison reports`}
            </li>
            <li className="flex gap-2">
              <CheckIcon className="text-primary size-5 shrink-0" />
              {t`Unlimited market reports`}
            </li>
          </ul>

          <ButtonLink
            to={props.userType === 'applicant' ? '/register/applicant' : '/register/company'}
          >{t`Sign up for free`}</ButtonLink>
        </div>

        <div className="bg-primary text-primary-foreground m-1.25 flex min-w-1/3 flex-col gap-3 rounded-lg p-7.5 font-medium shadow-lg">
          <h3>{t`Company`}</h3>

          <div className="flex items-center gap-1">
            <span className="text-2xl font-bold">149€</span>
            <span>/ {t`month + VAT`}</span>
          </div>

          <p>{t`You can use our solutions every day with great availability`}</p>
          <p>{t`Each month you will get:`}</p>

          <ul className="flex flex-col gap-1 text-sm">
            <li className="flex gap-2">
              <CheckIcon className="size-5 shrink-0" />
              {t`100 reports of positions, professionals, and teams`}
            </li>
            <li className="flex gap-2">
              <CheckIcon className="size-5 shrink-0" />
              {t`Unlimited comparison reports`}
            </li>
            <li className="flex gap-2">
              <CheckIcon className="size-5 shrink-0" />
              {t`Unlimited market reports`}
            </li>
          </ul>

          <ButtonLink
            className="bg-background text-foreground hover:bg-muted"
            to="/register/company"
          >{t`Choose this plan`}</ButtonLink>
        </div>

        <div className="m-1.25 flex min-w-1/3 flex-col gap-3 rounded-lg border p-7.5 font-medium">
          <h3 className="font-medium">{t`Integration`}</h3>
          <p className="text-sm font-medium">{t`To make large-scale integrations`}</p>

          <ul className="flex flex-col gap-1 text-sm font-medium">
            <li className="flex gap-2">
              <CheckIcon className="text-primary size-5 shrink-0" />
              {t`Unlimited job, professional, and team reports`}
            </li>
            <li className="flex gap-2">
              <CheckIcon className="text-primary size-5 shrink-0" />
              {t`Unlimited comparison reports`}
            </li>
            <li className="flex gap-2">
              <CheckIcon className="text-primary size-5 shrink-0" />
              {t`Unlimited market reports`}
            </li>
          </ul>

          <Button type="button" onClick={() => props.setOpenContact(true)}>{t`Contact us`}</Button>
        </div>

        {/* Purple and yellow background squares */}
        <div className="absolute top-1/2 -left-50 h-75 w-75 rotate-45 bg-linear-to-r from-purple-600 to-transparent" />
        <div className="absolute top-[20%] -right-50 h-75 w-75 rotate-45 bg-linear-to-l from-yellow-400 to-transparent" />
      </div>
    </section>
  )
}
